var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "select-bg" }, [
    _c("div", { staticClass: "select-container" }, [
      _c("div", { staticClass: "select-title" }, [
        _c(
          "div",
          {
            staticClass: "select-btn cancel-btn",
            on: {
              click: function ($event) {
                return _vm.$emit("cancel")
              },
            },
          },
          [_vm._v("取消")]
        ),
        _c(
          "div",
          {
            staticClass: "select-btn confirm-btn",
            on: {
              click: function ($event) {
                return _vm.$emit("confirm", _vm.selected)
              },
            },
          },
          [_vm._v("确定")]
        ),
      ]),
      _c(
        "div",
        { staticClass: "select-content" },
        _vm._l(_vm.options, function (option) {
          return _c(
            "div",
            {
              key: option.id,
              staticClass: "select-option",
              attrs: { "data-active": option.id === _vm.selected },
              on: {
                click: function ($event) {
                  _vm.selected = option.id
                },
              },
            },
            [
              _c("span", [_vm._v(_vm._s(option.name))]),
              option.id === _vm.selected
                ? _c("i", { staticClass: "el-icon-check" })
                : _vm._e(),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }